<!--
 * @Description: 
 * @Date: 2021-07-27 15:53:31
-->
<template>
  <div v-if="$route.query.from === 'jhss'" @click="jump">
    <p>
      体验更多功能 >>
    </p>
    <p>
      下载医生汇APP
    </p>
  </div>
</template>

<script>
export default {
  name: 'DownloadAPP',
  methods: {
    jump() {
      window.location.href =
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    }
  }
};
</script>

<style scoped lang="scss">
div {
  width: 100%;
  height: 1.28rem;
  position: fixed;
  bottom: 0;
  padding: 0.24rem 0;
  background: linear-gradient(180deg, #62cff8 0%, #0879e9 100%);
  box-shadow: -0.08rem 0.08rem 0.27rem 0px rgba(52, 168, 250, 0.56);
  display: flex;
  justify-content: center;
  align-items: center;
  p:first-child {
    font-size: 0.37rem;
    color: #fff;
    margin-right: 0.27rem;
  }
  p:last-child {
    width: 4.57rem;
    height: 0.85rem;
    background: transparent;
    border-radius: 0.43rem;
    font-weight: 500;
    color: #ffffff;
    font-size: 0.48rem;
    position: relative;
    text-align: center;
    &::after {
      content: ' ';
      width: 4.57rem;
      height: 0.85rem;
      background: #ffffff;
      border-radius: 0.43rem;
      opacity: 0.23;
      font-weight: 500;
      color: #ffffff;
      font-size: 0.48rem;
      position: absolute;
      left: 0;
    }
  }
}
</style>
